var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SectionHeadline",class:_vm.rootClasses},[_c('span',{staticClass:"Main"},[_vm._v(_vm._s(_vm.text))]),(_vm.extraText)?_c('span',{staticClass:"Exstra"},[_vm._v(_vm._s(_vm.extraText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }